import { Component, OnInit, Injector, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

const swal = require('sweetalert');
import { BehaviorSubject } from 'rxjs';
import { Usuario } from '../../../../models/usuario';
import { LoadingService } from '../../../../util/loader.service';
import { EmpresaService } from '../empresa.service';
import { Empresa } from '../../../../models/empresa';




@Component({
  selector: 'app-alterarsenha',
  templateUrl: './alterarsenha.component.html',
  styleUrls: ['./alterarsenha.component.scss']
})
export class AlterarsenhaComponent implements OnInit {
  blur = false;
  edicao: boolean = false;
  buttonType;
  valForm: FormGroup;
  router: Router;
  usuario = {
    id_usuario: null,
    novaSenha: null,
    repetirSenha: null
  };
  empresa:Empresa;
  constructor(public service: EmpresaService, public injector: Injector, fb: FormBuilder,
    private route: ActivatedRoute, private routerNavigate: Router, public loader: LoadingService) {
      this.empresa = new Empresa();
      this.route.queryParams.subscribe(params => {
        const record = JSON.parse(params['data']);
        this.empresa = record;
        this.usuario.id_usuario = record.id_usuarios;
      });
    //this.usuario.id_usuario = parseInt(this.route.snapshot.paramMap.get('id'));
    this.valForm = fb.group({
      'usuarioSenha': [null, Validators.required],
      'usuarioRepetirSenha': [null, Validators.required]
    });

  }

  submitForm($ev, value, buttonType: string) {

    $ev.preventDefault();
    // tslint:disable-next-line: forin
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.loader.show('body');
      this.service.alterarSenha(this.usuario)
      .subscribe(result => {
        this.loader.hide('body');
        this.callbackSave(result);
      });

    }
  }
  callbackSave(result) {
    if(result.success == true){
      swal('Atenção', 'Senha alterada com sucesso para: ' + result.senha + " .", 'success');
      this.valForm.reset();
      this.routerNavigate.navigate(['/v1/empresa']);
    }
  }
  ngOnInit() {
  }

}
